var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table, TableBody } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useState } from 'react';
import { GetLocalDeliveryData } from '../../../hooks/purchase-history-hooks';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import AlertBanner from '../../shared/AlertBanner';
import { TableSkeleton } from '../../shared/skeletons/TableSkeleton';
import NoOrdersView from '../NoOrdersView';
import { ODTableHeader, ODTableRow } from './index';
import { ODTableHeaderValues } from './ODTableHeaderData';
import { ODTablePagination } from './ODTablePagination';
export var ODTable = function (_a) {
    var _b, _c;
    var customerType = _a.customerType, orders = _a.orders;
    var _d = usePurchaseHistoryContext(), localDeliveryData = _d.localDeliveryData, localDeliveryError = _d.localDeliveryError, localDeliveryLoaded = _d.localDeliveryLoaded, setLocalDeliveryInfo = _d.setLocalDeliveryInfo, lDRequest = _d.lDRequest, localDeliveryAlertState = _d.localDeliveryAlertState, setLocalDeliveryAlertState = _d.setLocalDeliveryAlertState, setOpenAddReceiptDrawer = _d.setOpenAddReceiptDrawer;
    var _e = useState({ 0: 0 }), selected = _e[0], setSelected = _e[1];
    var _f = useState(false), ldDataRendered = _f[0], setLdDataRendered = _f[1];
    var _g = useState(ODTableHeaderValues()), tableHeaderState = _g[0], setTableHeaderState = _g[1];
    var data = GetLocalDeliveryData(lDRequest);
    if (data.localDeliveryLoaded &&
        setLocalDeliveryInfo &&
        ldDataRendered === false) {
        setLocalDeliveryInfo({
            localDeliveryData: data.localDeliveryData,
            localDeliveryError: data.localDeliveryError,
            localDeliveryLoaded: data.localDeliveryLoaded,
        });
        setLdDataRendered(true);
    }
    var totalNumberOfLocalDeliveries = (_b = localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orderCount) !== null && _b !== void 0 ? _b : 0;
    useEffect(function () {
        var _a;
        if (((_a = localDeliveryError === null || localDeliveryError === void 0 ? void 0 : localDeliveryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setLocalDeliveryAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
            return;
        }
        if (localDeliveryError) {
            setLocalDeliveryAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: 'Something went wrong on our end. Please check back later.',
                status: 'error',
            });
        }
    }, [localDeliveryError]);
    if (localDeliveryError) {
        return (React.createElement("div", { className: "sui-col-span-1" }, localDeliveryAlertState && (React.createElement(AlertBanner, __assign({}, localDeliveryAlertState)))));
    }
    if (localDeliveryLoaded &&
        (totalNumberOfLocalDeliveries === 0 ||
            ((_c = localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orders) === null || _c === void 0 ? void 0 : _c.length) === 0)) {
        return (React.createElement(ErrorBoundary, { name: "no-local-deliveries" },
            React.createElement(NoOrdersView, { customerType: customerType, setOpenAddReceiptModal: setOpenAddReceiptDrawer })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-overflow-x-scroll sui-mb-5" },
            React.createElement(Table, { unlined: true, layout: "fixed", density: "loose", className: "sui-shadow-none sui-w-full" },
                React.createElement(ODTableHeader, { tableHeaderState: tableHeaderState }),
                React.createElement(TableBody, null, localDeliveryLoaded ? (orders === null || orders === void 0 ? void 0 : orders.map(function (order, index) { return (React.createElement(ODTableRow, { index: index, order: order, selected: selected, customerType: customerType, setSelected: setSelected, orderLength: orders.length })); })) : (React.createElement(TableSkeleton, null))))),
        ((localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orderCount) || 0) > 0 && React.createElement(ODTablePagination, null)));
};
